export default {
    SENTRY_DSN: "https://cd0e9fae9afb4d398a69e255fb12e637@o4504418193965056.ingest.sentry.io/4504418196848640"
}